export default function PageLoadingFallback() {
  return (
    <div className="min-h-screen bg-crt-bg bg-cover bg-center text-white font-gaming flex items-center justify-center">
      <div className="animate-spin rounded-full h-16 w-16 border-4 border-purple-500 border-t-transparent" />
    </div>
  );
}
